import { ProductsCategoriesTranslations } from "#i18n/translations/pt-BR/org/products/categories";

export const ORG_PRODUCTS_CATEGORIES_FR_FR: ProductsCategoriesTranslations = {
	label: "Catégories",
	search: {
		label: "Rechercher",
		placeholder: "Catégorie, sous-catégorie ou produit",
	},
	add: "Nouvelle catégorie",
	categoryModal: {
		create: "Créer catégorie",
		createSubcategory: "Créer sous-catégorie",
		edit: "Modifier catégorie",
		inputs: {
			image: "Photo",
			name: {
				label: "Nom",
				placeholder: "Entrez le nom",
			},
			description: {
				label: "Description",
				placeholder: "Décrivez la catégorie",
			},
			priorityLevel: {
				label: "Niveau de priorité",
				errorMessage: "Entrez un niveau de priorité valide (ex: 1, 2, 3...)",
			},
			prefix: "Niveau",
			chartAccount: {
				label: "Plan de comptes",
				placeholder: "Sélectionnez le plan de comptes",
			},
			printOrder: {
				label: "Phase de la catégorie",
				placeholder: "Entrez la phase de la catégorie",
			},
			errors: {
				requiredName: "Le nom est obligatoire",
				requiredPriority: "Le niveau de priorité est obligatoire",
				invalidPriority: "Niveau de priorité invalide",
				requiredPrintOrder: "La phase de la catégorie est obligatoire",
				invalidPrintOrder: "Phase de la catégorie invalide",
			},
		},
	},
	columns: {
		product: "Produit",
		systemProduct: "Produit de système",
		actions: "Actions",
		combo: "Combo",
	},
	noSystemProduct: "Produit de système non lié",
	priorityLevel: "Niveau de priorité {{level}}",
	addSubcategory: "Ajouter une sous-catégorie dans {{category}}",
	addProduct: "Ajouter un produit dans {{category}}",
	deleteCategory:
		"Voulez-vous supprimer la catégorie ? Cette opération ne peut pas être annulée.",
	deleteProduct:
		"Voulez-vous supprimer ce produit ? Cette opération ne peut pas être annulée.",
	productModal: {
		edit: "Modifier le produit",
		create: "Créer un produit",
		inputs: {
			name: {
				label: "Nom",
				emptyError: "Le nom du produit n'est pas rempli",
				noStringError: "Utilisez uniquement des caractères valides",
				noCategory: "Le nom de la catégorie n'est pas rempli",
				noPriority: "Niveau de priorité invalide",
			},
			type: {
				label: "Type de produit",
				placeholder: "Sélectionnez un type de produit",
				error: "Sélectionnez un type de produit",
			},
			image: "Image",
			hasAlcohol: "Contient de l'alcool",
		},
	},
	subcategory: "sous-catégorie",
	subcategories: "Sous-catégories",
	description: "Description",
	chartAccount: "Plan de comptes",
	products: "Produits",
};
